// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IConsultationRequestRequest,
  TConsultationRequestModel,
  IMappers,
  TConsultationRequestResponse,
  IConsultationRequestResponse,
  IConsultationRequestResponseError,
} from './types';

export const defaultConfig: TConsultationRequestModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'e2e-deal-entrypoints',
  pathApi: '/v1/consultation-request/',
  requestType: 'json',
} as TConsultationRequestModel;

export function createConsultationRequestModel(parameters: IConsultationRequestRequest): TConsultationRequestModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IConsultationRequestOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IConsultationRequestRequest;
}

export async function fetchConsultationRequest<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IConsultationRequestOptions<TResponse200, TResponse400>): Promise<
  TConsultationRequestResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createConsultationRequestModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IConsultationRequestResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IConsultationRequestResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TConsultationRequestResponse;
}
